export const DELIVERY_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: 'delivery',
  // 対象テーブル
  TARGET_TABLE: 'delivery',
};
